import { OrganisationDetailResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export interface OrganisationDetail {
  displayName: string;
  samlProviderName: string;
  organisationId: number;
  emailDomains: string[];
  isCampaignEnabled: boolean;
  liftDataIds: number[];
  metadataUrl: string | null;
  s3Key: string | null;
  s3VersionId: string | null;
  isEnabled: boolean;
  customClaimClients: string[];
}

export function organisationDetailFromResponse(response: OrganisationDetailResponse): OrganisationDetail {
  return {
    displayName: response.display_name,
    samlProviderName: response.saml_provider_name,
    organisationId: response.organisation_id,
    emailDomains: response.email_domains,
    isCampaignEnabled: response.is_campaign_enabled,
    liftDataIds: response.lift_data_ids,
    metadataUrl: response.metadata_url ?? null,
    s3Key: response.s3_key ?? null,
    s3VersionId: response.s3_version_id ?? null,
    isEnabled: response.is_enabled,
    customClaimClients: response.custom_claim_clients,
  };
}

export default class GetOrganisationDetails extends BaseAdapter<OrganisationDetailResponse> implements AdapterInterface {
  rawResponse: OrganisationDetailResponse;

  async adaptResponse(organisationDisplayName: string): Promise<OrganisationDetail> {
    await this.fetchApiResponse('/api/organisation', HTTPMethod.Post, {
      organisation_display_name: organisationDisplayName,
    });

    return organisationDetailFromResponse(this.rawResponse);
  }
}
